"use strict";

define('libs/format/template',['underscore', 'handlebars'], function (_, Handlebars) {
  var templateFormatter = function templateFormatter(template, mapping) {
    return function (value, model) {
      var data = model.toJSON ? model.toJSON() : _.clone(model),
        isModel = false;
      if (model instanceof Backbone.Model) {
        isModel = true;
      }
      if (mapping) {
        _.each(mapping, function (attr, key) {
          if (attr === true) {
            attr = key;
          }
          if (isModel) {
            data[key] = model.get(attr);
          } else {
            data[key] = data[attr];
          }
        });
      }
      return new Handlebars.SafeString(template(data));
    };
  };
  return templateFormatter;
});

